import React, { useState } from 'react';
import { ColDef, IHeaderParams } from 'ag-grid-community';
import styled from 'styled-components';
import { ArrowDownIcon, ArrowUpIcon } from '@starrez/starryui';
import { ReactiveVar } from '@apollo/client';
import { color } from '@starryui10/theme/color';

export const LinkHeader = ({
    displayName,
    onClick,
    orderKey,
    cacheFunc,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
IHeaderParams & { cacheFunc: ReactiveVar<global.GridSortingVars>; onClick: (orderKey: any, order: global.SortOrderEnum) => void; orderKey: any }) => {
    const data = cacheFunc();

    const [sortingOrder, setSortingOrder] = useState<global.SortOrderEnum>('ASC');

    const handleOnClick = () => {
        let order: global.SortOrderEnum;

        if (data.field === orderKey) {
            // swap the orders
            if (data.order === 'DESC') {
                order = 'ASC';
            } else {
                order = 'DESC';
            }
        } else {
            // use the order we have already
            order = sortingOrder;
        }

        setSortingOrder(order);
        cacheFunc({ field: orderKey, order });
        onClick(orderKey, order);
    };

    return (
        <OrderButton
            display={data.field === orderKey}
            displayName={displayName}
            handleOnClick={handleOnClick}
            icon={data.field === orderKey ? data.order : sortingOrder}
        />
    );
};

const OrderButton = ({
    display,
    icon,
    handleOnClick,
    displayName,
}: {
    display: boolean;
    displayName: string;
    icon: global.SortOrderEnum;
    handleOnClick: () => void;
}) => (
    <Wrapper>
        <p onClick={handleOnClick}>{displayName}</p>
        <StyledButton type="button" display={display} onClick={handleOnClick}>
            {icon === 'ASC' ? <ArrowUpIcon Height="16px" Width="16px" /> : <ArrowDownIcon Height="16px" Width="16px" />}
        </StyledButton>
    </Wrapper>
);

export const Wrapper = styled.div`
    height: 30px;
    width: 100%;
    display: grid;
    align-items: center;
    gap: 8px;
    grid-template-columns: auto 30px;

    > p {
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0;
        margin: 0;
        cursor: pointer !important;
    }

    > p:hover {
        color: ${color.Blue.B80};
    }

    &:hover button {
        opacity: 1;
    }
`;

export const StyledButton = styled.button<{ display: boolean }>`
    background: none;
    border: none;
    height: 31px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    opacity: ${(props) => (props.display ? '1' : '0')};
    transition: opacity ease-in-out 0.2s;
    cursor: pointer;

    * {
        cursor: pointer !important;
    }

    &:hover {
        background: ${color.Blue.B20};
        color: ${color.Blue.B80};
    }
`;

export function useHeaderCell<T>(
    cacheFunc: ReactiveVar<global.GridSortingVars>,
    onClick: (orderKey: T, order: global.SortOrderEnum) => void
): (orderKey: T) => ColDef {
    return (orderKey: T) => ({
        headerComponentFramework: LinkHeader,
        headerComponentParams: {
            onClick,
            orderKey,
            cacheFunc,
        },
    });
}
